import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import PersonalAccount from "../../store/PersonalAccount";
import { buildShareLink, shareApp } from "../../utils/share";

export default function useController() {
  const [isCopy, setIsCopy] = useState(false);
  const { t } = useTranslation();

  const shareUrl = () => buildShareLink(PersonalAccount.user?.refCode);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl());
      setIsCopy(true);
    } catch (err) {
      setIsCopy(false);
      console.error("Не удалось скопировать текст: ", err);
      Sentry.captureException(err, {
        tags: {
          component: "FeedbackModal",
        },
        level: "warning",
      });
    }
  };

  const share = async () => {
    await shareApp({
      url: shareUrl(),
      text: t("share.invite_text"),
      sentryTag: "FeedbackModal",
    });
  };

  return {
    isCopy,
    handleCopy,
    share,
  };
}
